import { render, staticRenderFns } from "./GraphDetail71.vue?vue&type=template&id=c08b2e46&scoped=true"
import script from "./GraphDetail71.vue?vue&type=script&lang=js"
export * from "./GraphDetail71.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08b2e46",
  null
  
)

export default component.exports